import { ListGroup, Badge } from "react-bootstrap";
import {FaRegHandshake, FaHome, FaHeadset, FaBell, FaFileMedical, FaUserInjured, FaUserMd, FaFileContract, FaMoneyCheck, FaCoins, FaChartBar, FaFileMedicalAlt, FaCalendarAlt, FaDollarSign, FaTeamspeak, FaRobot, FaMapMarkedAlt} from "react-icons/fa";
import { TbTicket } from "react-icons/tb";
import { getCurrentUser, hasPerm } from '../../common/utils';
import { getConfig } from "../../common/config";


const MenuOperador = ({
  pathname,
  search,
  noDashboard,
  ocultar_receptivos,
  ocultar_atendimentos,
  ocultar_prestadores,
  gestao_aplicacoes,
  menus_adicionais,
  faturamentosPendentes,
  ambiente_programa_id,
  showSuporteMenu,
  habilitar_indicacao_profissional,
}) => {

  const dados_usuario = getCurrentUser();
  const configuracoes_programa = localStorage.getItem(`programa_configuracoes_${dados_usuario['ambiente_programa_id']}`);
  const podeVisualizarFluxoCeaf = hasPerm("view_ceaf_estado") || hasPerm("view_chamados") || dados_usuario?.tipo_usuario === 'operador';
  const podeVisualizarHistoricoCeaf = hasPerm("view_ceaf_auditoria_chatbot");

  return (
    <>
        {noDashboard === false && (
            <ListGroup variant="flush">
            <ListGroup.Item action href="/home" className="itemMenu" active={pathname.indexOf("/home") !== -1 || pathname === "/"} >
                <FaHome /> Home
            </ListGroup.Item>
            </ListGroup>
        )}

        <div className="list-divider">
            <p>Atendimento ao Paciente</p>
        </div>

        {hasPerm("view_agendamentos") && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/agendas" className="itemMenu" active={pathname === "/agendas" || pathname === "/agendas/" || (pathname === "/" && noDashboard)}>
              <FaCalendarAlt /> Agenda
            </ListGroup.Item>
          </ListGroup>
        )}

        {/* A operação só tinha a Agenda (calendário). A listagem de agendamentos existe e
            ela já tem a permissão — faltava o item no menu, então só chegava lá por dentro
            do atendimento. */}
        {hasPerm("view_agendamentos") && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/agendamentos" className="itemMenu" active={pathname.indexOf("/agendamentos") !== -1}>
              <FaCalendarAlt /> Agendamentos
            </ListGroup.Item>
          </ListGroup>
        )}

        {hasPerm("view_atendimentos") && (
            <>
                {!ocultar_atendimentos && (
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/atendimentos" className="itemMenu" active={pathname === "/atendimentos" || pathname === "/atendimentos/" || (pathname === "/" && noDashboard)} >
                            <FaHeadset /> Atendimentos
                        </ListGroup.Item>
                    </ListGroup>
                )}

                {Array.isArray(menus_adicionais) && menus_adicionais.length > 0 && (
                    <ListGroup variant="flush">
                        {menus_adicionais.map((menu) => (
                            <ListGroup.Item key={menu.id} action href={`/atendimentos-receptivo/?status=${menu.id}`} className="itemMenu" active={search === `?status=${menu.id}`} >
                                <FaHeadset /> {menu.menu_adicional_atendimento}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                )}
            </>
        )}

        {!ocultar_atendimentos && hasPerm("view_autorizacoes") && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/autorizacoes" className="itemMenu" active={pathname.indexOf("/autorizacoes") !== -1}>
              <FaFileContract /> Autorizações
            </ListGroup.Item>
          </ListGroup>
        )}

        {!ocultar_atendimentos && hasPerm("view_viewatendimentoscompliance") && gestao_aplicacoes && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/compliance" className="itemMenu" active={pathname.indexOf("/compliance") !== -1} >
              <FaFileContract /> Compliance de Terapia
            </ListGroup.Item>
          </ListGroup>
        )}

        {getConfig(configuracoes_programa, 'agendamento.despesas', false) === true && hasPerm("view_agendamentos_despesas") && (
          <ListGroup variant="flush">
              <ListGroup.Item action href="/despesas" className="itemMenu" active={pathname === "/despesas"} >
                  <FaDollarSign /> Despesas Agendamentos
              </ListGroup.Item>
          </ListGroup>
        )}

        {!ocultar_atendimentos && hasPerm("view_exames") && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/exames" className="itemMenu" active={pathname.indexOf("/exames") !== -1} >
              <FaFileMedical /> Exames
            </ListGroup.Item>
          </ListGroup>
        )}

        {hasPerm("view_atendimentos") && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/farmacovigilancia" className="itemMenu" active={pathname.indexOf("/farmacovigilancia") !== -1} >
              <FaFileMedical /> Farmacovigilancia
            </ListGroup.Item>
          </ListGroup>
        )}

        {hasPerm("view_atendimentos") && (
          <>
            {!ocultar_receptivos && (
              <ListGroup variant="flush">
                  <ListGroup.Item action href="/atendimentos-receptivo" className="itemMenu" active={pathname === "/atendimentos-receptivo" || (pathname === "/atendimentos-receptivo/" && !(search || "").includes("status")) } >
                      <FaHeadset /> Receptivos
                  </ListGroup.Item>
              </ListGroup>
            )}
          </>
        )}
               
        {!ocultar_atendimentos && hasPerm("pode_gerar_relatorio") && (
            <ListGroup variant="flush">
                <ListGroup.Item action href="/relatorios" className="itemMenu" active={pathname.indexOf("/relatorios") !== -1} >
                <FaChartBar /> Relatórios
                </ListGroup.Item>
            </ListGroup>
        )}

        {!ocultar_atendimentos && hasPerm('view_farmacovigilancia') && (
            <ListGroup variant="flush">   
                <ListGroup.Item 
                    action 
                    href="/reportes-farmaco"
                    className="itemMenu" 
                    active={pathname.indexOf("/reportes-farmaco") !== -1}
                >
                    <FaFileMedicalAlt /> Reportes FV
                </ListGroup.Item>      
            </ListGroup>
        )}   

        {((hasPerm("view_atendimentos") && hasPerm("view_faturamentos")) || getConfig(configuracoes_programa, 'agendamentos.despesas', false) === true) && (
          <>
            <div className="list-divider">
              <p>Gestão Financeira</p>
            </div>
          
            <ListGroup variant="flush">
                <ListGroup.Item action href="/extratoservicos" className="itemMenu" active={pathname === "/extratoservicos"} >
                    <FaMoneyCheck /> Extrato Serviços
                </ListGroup.Item>
            </ListGroup>

            <ListGroup variant="flush">
              <ListGroup.Item action href="/faturamentos" className="itemMenu" active={pathname.indexOf("/faturamentos") !== -1} >
                <FaCoins /> Faturamentos
                {faturamentosPendentes > 0 && (
                  <Badge pill bg="danger" className="ms-2">
                    {faturamentosPendentes}
                  </Badge>
                )}
              </ListGroup.Item>
            </ListGroup>
          </>
        )}

        <div className="list-divider">
            <p>Gerenciamento de Programas e Pacientes</p>
        </div>

        {hasPerm("view_prestadores") && !ocultar_prestadores && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/medicos" className="itemMenu" active={pathname.indexOf("/medicos") !== -1} >
              <FaUserMd /> Médicos
            </ListGroup.Item>
          </ListGroup>
        )}

        {hasPerm("view_beneficiarios") && hasPerm("add_beneficiarios") && (
            <ListGroup variant="flush">
              <ListGroup.Item action href="/pacientes" className="itemMenu" active={pathname.indexOf("/pacientes") !== -1} >
                <FaUserInjured /> Pacientes
              </ListGroup.Item>
            </ListGroup>
        )}

        {hasPerm("view_prestadores") && !ocultar_prestadores && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/prestadores" className="itemMenu" active={pathname.indexOf("/prestadores") !== -1} >
              <FaUserMd /> Provedores
            </ListGroup.Item>
          </ListGroup>
        )}

        {/* so em programa que oferece indicacao: a fila nao existe nos demais */}
        {hasPerm("view_prestadores") && habilitar_indicacao_profissional && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/indicacoes-recebidas" className="itemMenu" active={pathname.indexOf("/indicacoes-recebidas") !== -1} >
              <FaRegHandshake /> Indicações Recebidas
            </ListGroup.Item>
          </ListGroup>
        )}

      {(podeVisualizarFluxoCeaf || podeVisualizarHistoricoCeaf) && (
        <>
          <div className="list-divider">
            <p>CEAF</p>
          </div>
          <ListGroup variant="flush">
            {podeVisualizarFluxoCeaf && (
              <ListGroup.Item action href="/fluxo-ceaf" className="itemMenu" active={pathname.indexOf("/fluxo-ceaf") !== -1}>
                <FaMapMarkedAlt /> Fluxo CEAF
              </ListGroup.Item>
            )}
            {podeVisualizarHistoricoCeaf && (
              <ListGroup.Item action href="/historico-chatbot" className="itemMenu" active={pathname.indexOf("/historico-chatbot") !== -1}>
                <FaRobot /> Histórico Chatbot
              </ListGroup.Item>
            )}
          </ListGroup>
        </>
      )}

      {hasPerm("view_chamados") && showSuporteMenu && (
        <>
          <div className="list-divider">
              <p>Suporte</p>
          </div>
          <ListGroup variant="flush">
            <ListGroup.Item action href="/chamados" className="itemMenu" active={pathname.indexOf("/chamados") !== -1} >
              <TbTicket /> Chamados
            </ListGroup.Item>

            <ListGroup.Item action href="/notificacoes" className="itemMenu" active={pathname.indexOf("/notificacoes") !== -1} >
                <FaBell /> Notificações
            </ListGroup.Item>

            {getConfig(configuracoes_programa, 'ativar_faq', false) === true && (
              <ListGroup.Item action href="/faq" className="itemMenu" active={pathname.indexOf("/faq") !== -1}>
                <FaTeamspeak /> FAQ
              </ListGroup.Item>
            )}
          </ListGroup>

        </>
      )}
    </>
  );
};

export default MenuOperador;
